import {lazy} from 'react';

export const GlossaryLazy = lazy(() => import(/* webpackChunkName: "glossary" */ '.'));
